import {gtmEcommerceOfferTypeMap} from "@pg-rp/common-types";

import {hitGoogleTagManager} from "../../../../tracking/google_tag_manager/hit_google_tag_manager";
import {IGTMEcommerce} from "../../../../tracking/types/ecommerce/IGTMEcommerce";
import {IGTMEcommerceItem} from "../../../../tracking/types/ecommerce/IGTMEcommerceItem";
import {getCurrencyISOCode} from "../../../../utils/get_currency";
import {OfferType} from "../../../types/OfferType";
import {getGtmEcommerceOfferItemBaseProps} from "../common/get_gtm_ecommerce_offer_item_base_props";
import {getGTMEcommerceOfferRegion} from "../common/get_gtm_ecommerce_offer_region";
import {getGTMEcommercePropertyProps, IGetGtmEcommercePropertyPropsFull} from "../common/get_gtm_ecommerce_property_props";
import {IHitGTMOfferWishlistParams} from "../offer/hit_gtm_offer_add_to_wishlist";
import {GTMEcommerceAvailability} from "../types/gtm_ecommerce_availability";
import {GTMEcommerceItemStatus} from "../types/gtm_ecommerce_item_status";

export type IHitGTMPropertyAddToWishlistParams = {
    offer: IHitGTMOfferWishlistParams["offer"];
    property: IGetGtmEcommercePropertyPropsFull;
};

export const hitGTMPropertyAddToWishlist = (params: IHitGTMPropertyAddToWishlistParams) => {
    const offerData = params.offer;
    const propertyData = params.property;
    const item = {
        ...getGtmEcommerceOfferItemBaseProps(offerData),
        item_category: "property",
        price: 1,
        quantity: 1,
        availability: GTMEcommerceAvailability.IN_STOCK,
        item_status: GTMEcommerceItemStatus.Active,
        item_type: gtmEcommerceOfferTypeMap[offerData.type as OfferType],
        item_comissioning_date: offerData?.construction_date_range?.upper || "na",
        ...getGTMEcommerceOfferRegion(offerData.region),
        ...getGTMEcommercePropertyProps({
            property: propertyData,
            short: false
        })
    } as IGTMEcommerceItem;

    const ecommerce: IGTMEcommerce = {
        currency: getCurrencyISOCode(offerData.currency),
        value: 1,
        items: [item]
    };

    hitGoogleTagManager({
        event: "add_to_wishlist",
        ecommerce
    });
};
import {gtmEcommerceOfferTypeMap} from "@pg-rp/common-types";

import {hitGoogleTagManager} from "../../../../tracking/google_tag_manager/hit_google_tag_manager";
import {IGTMEcommerce} from "../../../../tracking/types/ecommerce/IGTMEcommerce";
import {IGTMEcommerceItem} from "../../../../tracking/types/ecommerce/IGTMEcommerceItem";
import {getCurrencyISOCode} from "../../../../utils/get_currency";
import {OfferType} from "../../../types/OfferType";
import {getGtmEcommerceOfferItemBaseProps} from "../common/get_gtm_ecommerce_offer_item_base_props";
import {getGTMEcommerceOfferRegion} from "../common/get_gtm_ecommerce_offer_region";
import {getGTMEcommercePropertyProps, IGetGtmEcommercePropertyPropsFull} from "../common/get_gtm_ecommerce_property_props";
import {IHitGTMOfferWishlistParams} from "../offer/hit_gtm_offer_add_to_wishlist";
import {GTMEcommerceAvailability} from "../types/gtm_ecommerce_availability";
import {GTMEcommerceItemStatus} from "../types/gtm_ecommerce_item_status";

export type IHitGTMPropertyAddToWishlistParams = {
    offer: IHitGTMOfferWishlistParams["offer"];
    property: IGetGtmEcommercePropertyPropsFull;
};

export const hitGTMPropertyAddToWishlist = (params: IHitGTMPropertyAddToWishlistParams) => {
    const offerData = params.offer;
    const propertyData = params.property;
    const item = {
        ...getGtmEcommerceOfferItemBaseProps(offerData),
        item_category: "property",
        price: 1,
        quantity: 1,
        availability: GTMEcommerceAvailability.IN_STOCK,
        item_status: GTMEcommerceItemStatus.Active,
        item_type: gtmEcommerceOfferTypeMap[offerData.type as OfferType],
        item_comissioning_date: offerData?.construction_date_range?.upper || "na",
        ...getGTMEcommerceOfferRegion(offerData.region),
        ...getGTMEcommercePropertyProps({
            property: propertyData,
            short: false
        })
    } as IGTMEcommerceItem;

    const ecommerce: IGTMEcommerce = {
        currency: getCurrencyISOCode(offerData.currency),
        value: 1,
        items: [item]
    };

    hitGoogleTagManager({
        event: "add_to_wishlist",
        ecommerce
    });
};
